import React from 'react';
import { useParams } from 'react-router-dom';
import { useParcelByTms } from '../hooks';
import ParcelDetailsView from './ParcelDetailsView';


const ParcelDetailsByTms: React.FC = () => {
  const { tms } = useParams();
  const { parcel, error, isLoading } = useParcelByTms(tms);

  if (!parcel && error && 'status' in error) {
    console.error('fetch error', error)
  }

  return <ParcelDetailsView parcel={parcel} isLoading={isLoading} />
};

export default ParcelDetailsByTms;